import { formatI18n } from '../I18n/I18n/I18n';
export default formatI18n;